import React from 'react';
import _ from 'lodash';
import {
  ROLE_TO_ROLES_MAP,
  ROLE_MAP,
  PERMISSIONS_MAP,
  PERMISSIONS_MAP_V2,
} from './constants';
import {Message} from 'semantic-ui-react';

export function validateCells(rows) {
  return _.every(rows, (vals) => {
    if (!_.isObject(vals)) {
      return false;
    } else if (_.some(vals, _.isEmpty)) {
      return false;
    } else {
      return true;
    }
  });
}

export const mapValuesToBody = (values, orgs) => {
  let entityId = values.entity;
  let roleId = _.invert(ROLE_MAP)[values.role];

  return {
    userId: values.email.toLowerCase(),
    entityId: entityId,
    roleId: roleId,
    entityTypeId: values.entityTypeId,
  };
};

export const createEntityOptions = (rolePayload) => {
  return _.filter(
    _.uniqBy(
      _.map(rolePayload, (role) => {
        return {
          text: role.displayName,
          value: role.entityId,
        };
      }),
      'value'
    ),
    (role) => {
      return role.value !== null;
    }
  );
};

export const createRoleOptions = (payload, rolesFromPermissions) => {
  let roleMap = {};
  let entity = '';
  let userEntityRoles = {};
  _.forEach(payload, (role) => {
    entity = role.entity.entityId;
    if (_.has(userEntityRoles, entity)) {
      userEntityRoles[entity] = userEntityRoles[entity].concat(role.roles);
    } else {
      userEntityRoles[entity] = role.roles;
    }
  });

  _.forIn(userEntityRoles, (roles, entity) => {
    let rolesForEntity = _.intersection(
      rolesFromPermissions,
      _.map(roles, (role) => _.toString(role.roleId))
    );
    let assignableRoles = selectableRoles(rolesForEntity);
    _.forEach(assignableRoles, (roleInArray) => {
      if (_.has(roleMap, entity)) {
        roleMap[entity].push({
          text: roleInArray,
          value: roleInArray,
        });
      } else {
        roleMap[entity] = [
          {
            text: roleInArray,
            value: roleInArray,
          },
        ];
      }
    });
  });
  _.forEach(
    roleMap,
    (entity, index) =>
      (roleMap[index] = _.orderBy(
        _.uniqWith(entity, _.isEqual),
        [(record) => _.toLower(_.get(record, 'text', ''))],
        ['asc']
      ))
  );
  return roleMap;
};

export const selectableRoles = (roles) => {
  let selectableRolesList = [];
  let roleTemp = [];

  _.each(_.intersection(roles, _.keys(ROLE_TO_ROLES_MAP)), (roleId) => {
    roleTemp = roleTemp.concat(ROLE_TO_ROLES_MAP[roleId]);
  });

  _.each(_.uniq(roleTemp), (roleId) => {
    selectableRolesList.push(ROLE_MAP[roleId]);
  });

  return selectableRolesList;
};

export const createRolePermissionsBox = (roles, toggles) => {
  const permissionsMapToUse = _.includes(toggles, 'femaReviewSubGrants')
    ? PERMISSIONS_MAP_V2
    : PERMISSIONS_MAP;
  if (roles != null) {
    const items = _.map(roles, (role) => {
      return (
        <div key={role}>
          <strong>{role}</strong> - {permissionsMapToUse[role]}
        </div>
      );
    });
    return <Message info icon="info circle" content={items} header="Role Permissions" />;
  }
};
